import * as HttpService from "../../../../service/HttpService";

/**  用能概览 -> 用户服务 **/

const MOCK_ADDRESS = "https://www.fastmock.site/mock/588ccf88c91f9bd2d33c3ef66b76939d/smart";

/**
 * 获取基本信息
 */
export const getBasicInfo = (custId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewReResource/getEnergyCustInfo?custId=" + custId);
}

/**
 * 获取用能概况
 */
export const getEnergyOverview = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getCecustEconsSurvey?custId=" + customId);
}

/**
 * 获取管控收益
 */
export const getControlEarning = (customId, type) => {
    return HttpService.get(HttpService.DOMAIN  + "/viewEsMgmt/getEsMgmtStatCustDiagram?custId=" + customId + "&type=" + type);
}

/**
 * 获取负荷曲线
 */
export const getLoadCurve = (customId, type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getCustEloadYMDOfDiagram?custId=" + customId + "&type=" + type);
}

/**
 * 获取电度成本
 */
export const getPowerCost = (customId, type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewMbCustBill/getCustElectricalCost?custId="  + customId + "&type=" + type);
}

/**
 * 获取电费及电量情况
 */
export const getElectCondition = (customId, type) => {
    return HttpService.get(HttpService.DOMAIN  + "/viewStatisticalPower/getCustElectricQuantityAndPrice?custId=" + customId + "&type=" + type);
}

/**
 * 获取分项能耗
 */
export const getEnergyConsumption = (customId, type) => {
    return HttpService.get(HttpService.DOMAIN + "/statCebsdClsEcons/getDeviceEconsProportionByCustId?type="+ type +"&custId=" + customId);
}

/**
 * 获取用能统计信息
 */
export const getEnergyStatistic = (customId) => {
    return HttpService.get(HttpService.DOMAIN  + "/viewEsMgmt/getEsMgmtOutPlanEventByCustId?id=" + customId);
}


/**
 * 获取水费
 */
export const getWaterBill = (data) => {
    return HttpService.post(HttpService.DOMAIN  + "/wcons/getBill",data);
}
/**
 * 用电构成
 */
export const getWconsConstitute = (data) => {
    return HttpService.post(HttpService.DOMAIN  + "/wcons/getWconsConstitute",data);
}